var map = {
	"./video-00-grundlagen/video.js": "./src/lib/edu/video-00-grundlagen/video.js",
	"./video-01-musik-dein-erster-beat/video.js": "./src/lib/edu/video-01-musik-dein-erster-beat/video.js",
	"./video-02-musik-die-band-party-on/video.js": "./src/lib/edu/video-02-musik-die-band-party-on/video.js",
	"./video-03-musik-die-beat-station/video.js": "./src/lib/edu/video-03-musik-die-beat-station/video.js",
	"./video-04-musik-stopptanz-maschine/video.js": "./src/lib/edu/video-04-musik-stopptanz-maschine/video.js",
	"./video-05-musik-blumen-memo-spiel/video.js": "./src/lib/edu/video-05-musik-blumen-memo-spiel/video.js",
	"./video-06-hallo-welt/video.js": "./src/lib/edu/video-06-hallo-welt/video.js",
	"./video-07-weltraum-maus/video.js": "./src/lib/edu/video-07-weltraum-maus/video.js",
	"./video-08-maus-blinzelt/video.js": "./src/lib/edu/video-08-maus-blinzelt/video.js",
	"./video-09-maus-tanzt/video.js": "./src/lib/edu/video-09-maus-tanzt/video.js",
	"./video-10-wimmelbild/video.js": "./src/lib/edu/video-10-wimmelbild/video.js",
	"./video-11-kunst-mit-der-maus/video.js": "./src/lib/edu/video-11-kunst-mit-der-maus/video.js",
	"./video-12-zahlen-raten/video.js": "./src/lib/edu/video-12-zahlen-raten/video.js",
	"./video-13-mathefant/video.js": "./src/lib/edu/video-13-mathefant/video.js",
	"./video-14-deine-story/video.js": "./src/lib/edu/video-14-deine-story/video.js",
	"./video-15-kugelfisch/video.js": "./src/lib/edu/video-15-kugelfisch/video.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/lib/edu sync recursive video.+\\/video\\.js$";